var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('iframe',{staticStyle:{"border":"0","height":"100%"},attrs:{"width":"100%","height":"100%","src":_vm.myURL}})])}
var staticRenderFns = []

export { render, staticRenderFns }